import * as types from '../../../constants/ActionNameConstants';

const initialState = {
  loading: false,
  user: [],
  error: null,
};

const ReadNotificationReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.READ_NOTIFICATION_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.READ_NOTIFICATION_SUCCESS:
      return {
        ...state,
        loading: false,
        user: action.payload,
      };
    case types.READ_NOTIFICATION_FAILED:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    default:
      return state;
  }
};

export default ReadNotificationReducer;
